import React, { useEffect, useState } from "react";
import TransactionCard from "./TransactionCard";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import Loader from "../../../components/Loader";
import DepositReqModal from "../../../components/Modals/DepositReqModal";
import WithdrawReqModal from "../../../components/Modals/WithdrawReqModal";

const Transactions = () => {
  const axiosPrivate = useAxiosPrivate();
  const [tData, setTData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [selectedTab, setSelectedTab] = useState("all");
  const [showDepositModal, setshowDepositModal] = useState(false);
  const [showWithdrawModal, setshowWithdrawModal] = useState(false);
  const [selectedData, setSelectedData] = useState(null);

  //Paginations
  // const [currentPage, setCurrentPage] = useState(1);
  // const itemsPerPage = 8;

  // const indexOfLastItem = currentPage * itemsPerPage;
  // const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  // const currentData = filteredData.slice(indexOfFirstItem, indexOfLastItem);

  // Pagination Handlers
  // const totalPages = Math.ceil(filteredData.length / itemsPerPage);
  // const nextPage = () =>
  //   setCurrentPage((prev) => Math.min(prev + 1, totalPages));
  // const prevPage = () => setCurrentPage((prev) => Math.max(prev - 1, 1));
  // const handlePageClick = (page) => setCurrentPage(page);

  // Tracks the active tab
  const [loading, setLoading] = useState(false);
  const handleTabChange = (tab) => {
    setSelectedTab(tab);
    if (tab === "all") {
      setFilteredData(tData);
    } else if (tab === "deposits") {
      setFilteredData(tData.filter((item) => item.type === "deposit"));
    } else if (tab === "withdraws") {
      setFilteredData(tData.filter((item) => item.type === "withdraw"));
    }
  };

  const handleOnClose = () => {
    setshowDepositModal(false);
    setshowWithdrawModal(false);
  };

  useEffect(() => {
    // Fetch initial listings
    setLoading(true);
    const fetchListings = async () => {
      await axiosPrivate
        .get(`/easypaisa/transactions/`, {
          withCredentials: true,
        })
        .then((res) => {
          console.log(res.data);
          setTData(res?.data?.transactions);
          setFilteredData(res?.data?.transactions);
          setLoading(false);
          // setMatch(res.data);
        })
        .catch((err) => {
          setLoading(false);
          console.log(err);
        });
    };

    fetchListings();

    // Clean up the socket connection
    return () => {};
  }, [axiosPrivate]);

  return (
    <div>
      {selectedData && selectedData?.type === "deposit" ? (
        <>
          <DepositReqModal
            visible={showDepositModal}
            onClose={handleOnClose}
            data={selectedData}
            key={selectedData?._id}
          />
        </>
      ) : (
        <>
          <WithdrawReqModal
            visible={showWithdrawModal}
            onClose={handleOnClose}
            data={selectedData}
            key={selectedData?._id}
          />
        </>
      )}

      <div className="sm:px-6 w-full">
        <div className="px-4 md:px-10 py-4 md:py-7">
          <div className="flex items-center justify-between">
            <p
              tabindex="0"
              className="focus:outline-none text-base sm:text-lg md:text-xl lg:text-2xl font-bold leading-normal text-white"
            >
              Transactions
            </p>
          </div>
        </div>
        <div className="bg-black bg-opacity-50 py-4 md:py-7 px-4 md:px-8 xl:px-10">
          <div className="sm:flex items-center justify-between">
            <div className="md:flex items-center">
              <button className="rounded-full focus:outline-none focus:ring-2  focus:bg-indigo-50 focus:ring-indigo-800">
                <button
                  onClick={() => handleTabChange("all")}
                  className={`py-2 px-8 rounded-full ${
                    selectedTab === "all"
                      ? "bg-indigo-100 text-indigo-700"
                      : "text-gray-600 hover:text-indigo-700 hover:bg-indigo-100"
                  }`}
                >
                  <p>All</p>
                </button>
              </button>
              <button className="rounded-full focus:outline-none focus:ring-2 focus:bg-indigo-50 focus:ring-indigo-800 ml-4 sm:ml-8">
                <button
                  onClick={() => handleTabChange("deposits")}
                  className={`py-2 px-8 rounded-full ${
                    selectedTab === "deposits"
                      ? "bg-indigo-100 text-indigo-700"
                      : "text-gray-600 hover:text-indigo-700 hover:bg-indigo-100"
                  }`}
                >
                  <p>Deposits</p>
                </button>
              </button>
              <button className="rounded-full focus:outline-none focus:ring-2 focus:bg-indigo-50 focus:ring-indigo-800 ml-4 sm:ml-8">
                <button
                  onClick={() => handleTabChange("withdraws")}
                  className={`py-2 px-8 rounded-full ${
                    selectedTab === "withdraws"
                      ? "bg-indigo-100 text-indigo-700"
                      : "text-gray-600 hover:text-indigo-700 hover:bg-indigo-100"
                  }`}
                >
                  <p>Withdrawals</p>
                </button>
              </button>
            </div>
          </div>
          {loading ? (
            <Loader />
          ) : filteredData.length > 0 ? (
            <>
              <div className="mt-7 h-[400px] overflow-y-auto">
                <table className="w-full whitespace-nowrap ">
                  <tbody>
                    {filteredData?.map((data) => {
                      return (
                        <tr
                          onClick={() => {
                            setSelectedData(data);
                            if (data?.type === "deposit") {
                              setshowDepositModal(true);
                            } else {
                              setshowWithdrawModal(true);
                            } // Set selected data
                          }}
                          tabindex="0"
                          className="focus:outline-none h-16 border text-xs border-gray-100 rounded"
                        >
                          <TransactionCard key={data?._id} data={data} />
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
              {/* <div className="flex items-center justify-between mt-4">
                <button
                  onClick={prevPage}
                  disabled={currentPage === 1}
                  className={`px-4 py-2 rounded ${
                    currentPage === 1
                      ? "bg-gray-300 cursor-not-allowed"
                      : "bg-indigo-500 text-white hover:bg-indigo-600"
                  }`}
                >
                  Previous
                </button>

                <div className="flex space-x-2">
                  {Array.from({ length: totalPages }, (_, index) => (
                    <button
                      key={index + 1}
                      onClick={() => handlePageClick(index + 1)}
                      className={`px-4 py-2 rounded ${
                        currentPage === index + 1
                          ? "bg-indigo-500 text-white"
                          : "bg-gray-200 hover:bg-gray-300"
                      }`}
                    >
                      {index + 1}
                    </button>
                  ))}
                </div>

                <button
                  onClick={nextPage}
                  disabled={currentPage === totalPages}
                  className={`px-4 py-2 rounded ${
                    currentPage === totalPages
                      ? "bg-gray-300 cursor-not-allowed"
                      : "bg-indigo-500 text-white hover:bg-indigo-600"
                  }`}
                >
                  Next
                </button>
              </div> */}
            </>
          ) : (
            <>
              <div className="w-full flex justify-center rounded-xl items-center h-[400px] bg-black bg-opacity-50">
                <p className="text-gray-400 font-bold">
                  No Transactions Found.
                </p>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default Transactions;
